'use strict';


class ReCaptcha {
  constructor() {
    this._loaded = false;
    this._calbacks = [];

    const metaKey = document.querySelector('meta[name=recaptcha]');

    if (!metaKey) {
      this._loaded = true;
      this._calbacks.forEach((func) => func());
      return;
    }

    this._key = metaKey.getAttribute('content');

    this._init();
  }
  _init() {
    // const container = document.createElement('div');
    // container.id = 'recaptcha';
    // container.style.display = 'none';

    window.onCaptchaLoad = () => {
      this._loaded = true;

      this._calbacks.forEach((func) => func());
    };

    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?onload=onCaptchaLoad&render=${this._key}`;
    script.async = true;

    let firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
  }


  subscribe(func) {
    if (typeof func !== 'function') return;
    if (this._loaded) {
      func();
    } else {
      this._calbacks.push(func);
    }
  }
  unsubscribe(func) {
    if (typeof func !== 'function') return;
    const index = this._calbacks.indexOf(func);
    this._calbacks.splice(index, 1);
  }
  get loaded() {
    return this._loaded;
  }
  get key() {
    return this._key;
  }
}

export const reCaptcha = new ReCaptcha();

export default reCaptcha;